
import * as base from "../lib/PageBase";

export const _getInputService = () => {

    let header = {
        'Content-Type': 'application/x-www-form-urlencoded'
    };
    let url =`${base.baseUrlMasters}`;

    return fetch(url, {
        method: 'GET',
        headers: header
    })
    .then(res => res.json())
}
